var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parking_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 0.5,
    y: 0.5,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.5 5.5a3.5 3.5 0 1 1 0 7H7v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M6.75 12.25h.5v6.5h-.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "parking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgParking;